export enum Compatibility
{
    HTML,
    SVG,
    Polymorphic
}
